module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAABBElEQVQokXXRsSvEYRzH8df9+mWxCteRf8BgINlkuCxKcYusTq4UGWTQlU1G9ctikPE3+BeUyEh25ZIzXBkMGPgZ7jndHT71DM/7+Xy/3z7fJ5dlGaXKCqrI4xxlNHCIBXzgCLu5bHFtGac69YBnTHbxaoxtvzUSTrfKEUbbwA3G8P6HGQoRXtrAFmKc/FNQj7GEQTzhDVcoagY/wD6+QsFnjEvsYQrz6MEMNsKk45Anh7lImryiN3TsD51Wg3Fdc63juJAm9TgYNjERAsMA7tEX7rfYgVyWZU1UqgzhGoWuoM3/SJMaRD84TR4xjVqbuYFiy9w5oaVSJY8zDGNWmty1P38Dc/hAvmml97gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/healthIcon/xinlv-4.png
// module id = cFsi
// module chunks = 4